import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', './../public.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
    ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({        //controlsConfig: {
      email: '',
      password: ''
    });
  }

  submit() {
    const data = this.form.getRawValue();

    this.authService.login(data).subscribe(
      (res: any)=>{
        localStorage.setItem('token', res.api_token);
        console.log(res);
        localStorage.setItem('user', res.user);
        this.router.navigate(['/capture']);
        //console.log(res);
      }
    )
     //console.log(this.form.getRawValue())
  }

}
